export default function minWidthViewport(): void {
  const viewport = document.querySelector("meta[name=viewport]");
  
  if (viewport) {
    const content = viewport.getAttribute("content");
    const reg = /min-width=(\d+)/;
    const match = content ? content.match(reg) : null;
    
    if (match && match[1]) {
      const minWidth = parseInt(match[1]);

      if (document.head && window.screen.width < minWidth) {
        document.head.removeChild(viewport);
        const newViewport = document.createElement("meta");
        newViewport.setAttribute("name", "viewport");
        newViewport.setAttribute("content", "width=" + minWidth);
        document.head.appendChild(newViewport);
      }
    }
  }
}
